import Dashboard from './Dashboard';
import Sessions from './Sessions';
import SessionDetail from './SessionDetail';

export default {
  Dashboard,
  Sessions,
  SessionDetail,
};
